import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { FilesAppState, FilesAssetSubtitle } from './types';

const initialState: FilesAppState = {
  assetSubtitles: [],
};

export const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    clearAssetSubtitles: (state) => {
      state.assetSubtitles = [];
    },

    setAssetSubtitles: (state, action: PayloadAction<FilesAssetSubtitle[]>) => {
      state.assetSubtitles = action.payload;
    },

    loadingAssetFormatsData: (state, action: PayloadAction<boolean>) => {
      state.loadingAssetFormatsData = action.payload;
    },
  },
});

export const {
  clearAssetSubtitles,
  setAssetSubtitles,
  loadingAssetFormatsData,
} = filesSlice.actions;

export const filesReducer = filesSlice.reducer;
